import './LoadingState.css';
export var loadingStateCSS = '_1s087yh0-2-0-1';